import React from 'react';
import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const SortIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 10 10',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <path
      d="M7.42872573,5.99863865 L8.10053927,6.65117249 L5.30017328,9.53419937 L2.5,6.6511843 L3.17171194,5.99863865 L5.30018253,8.18980216 L7.42872573,5.99863865 Z M5.30017328,0.833333333 L8.10053927,3.71636021 L7.42872573,4.36889406 L5.30018253,2.17773054 L3.17171194,4.36889406 L2.5,3.7163484 L5.30017328,0.833333333 Z"
      id="Combined-Shape"
    ></path>
  </SvgIcon>
);

export default SortIcon;
